import { render, staticRenderFns } from "./DocumentsChips.vue?vue&type=template&id=11dc8c7b&"
import script from "./DocumentsChips.vue?vue&type=script&lang=js&"
export * from "./DocumentsChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports